import { render, staticRenderFns } from "./BubuiaWrapper.vue?vue&type=template&id=e49bc48c&scoped=true&"
import script from "./BubuiaWrapper.vue?vue&type=script&lang=js&"
export * from "./BubuiaWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BubuiaWrapper.vue?vue&type=style&index=0&id=e49bc48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49bc48c",
  null
  
)

export default component.exports